/**
 * 문자 발송 (/adm/sms-send) — 발송내역 · 통계 · 광고 문자(수신거부 번호) · 수동발송 모달(비즈고 SMS/LMS/MMS/RCS)
 * ($j.Pages.Admin.SmsSend / body data-page-name="SmsSend")
 *
 * 예전 blade 인라인 스크립트를 로직 그대로 옮겼다. 서버 값은 #page-data 로 받는다.
 * 처음 숨겨 둔 요소 중 몇 개(#sm_final_direct·#sm_final_match·#sm_from_rcs·.sm-count-spin)는 hidden 속성으로
 * 켜고 끈다 — jQuery .show() 는 스타일시트 display(flex·block)가 아니라 태그 기본값으로 되돌리기 때문이다.
 * 마크업·스타일은 adm/pages/smsSend.blade.php · sass/admin/pages/_sms-send.scss.
 */

let $table = null;
const SMS_BYTE_LIMIT = 90;

// 용도 코드 → 표시명. 저장값은 코드 그대로, 화면에만 한글. (AlimTemplateRenderer 와 공유)
// 서버 값 — #page-data (SmsSendController::index)
const PAGE = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
const PURPOSE_LABELS = PAGE.purposeLabels;
const DETAIL_LABELS  = PAGE.detailPurposeLabels;

// 통계 막대색 — 발송건수순 정렬로 순서가 바뀌어도 용도별 색은 항상 같게(코드로 고정 매핑).
// 다른 관리자 통계 화면(OrderStat.js/MemberCurrent.js)과 같은 팔레트에서 골랐다.
const PURPOSE_COLORS = { match: '#0d6efd', tax: '#198754', whan: '#fd7e14', devil: '#6610f2', manual: '#20a8a8' };
const PURPOSE_COLOR_FALLBACK = '#e83e8c'; // 위 매핑에 없는 용도 코드가 나타난 경우
const TOTAL_COLOR = '#6c757d';

// ── 080 수신거부 내역 반영 — CSV 를 한 번 읽어 회원의 「광고 문자」 동의를 철회로 돌린다. 파일·번호는 남지 않는다 (SmsAdOptOutService) ──
function importOptOut() {
    const file = this.files && this.files[0];
    this.value = '';
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    const $btn = $('#dn_csv_btn').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> 반영 중…');
    const restore = () => $btn.prop('disabled', false).html('<i class="fa fa-file-csv"></i> CSV 올리기');
    const n = (v) => Number(v || 0).toLocaleString();
    $.ajax({ url: '/adm/ajax/sms-send/ad-optout', method: 'POST', data: fd, processData: false, contentType: false, dataType: 'json' })
     .done(res => {
         restore();
         if (!res.result) { $j.Ui.Dialog.open({tone:'warn', title: res.message || 'CSV 올리기 실패'}); return; }
         $j.Ui.Dialog.open({
             tone: res.withdrawn ? 'success' : 'warn', align: 'left',
             title: `${escapeHtml(file.name)} — 번호 ${n(res.phones)}개를 읽었습니다`,
             desc: '광고 문자 동의를 철회로 돌렸습니다. 파일은 보관하지 않으며, 회원이 설정에서 다시 켜면 다시 받습니다.',
             rows: [
                 { k: '광고 문자 해제', v: `${n(res.withdrawn)}명` },
                 { k: '이미 꺼짐', v: `${n(res.already_off)}명` },
                 { k: '회원 아님', v: `${n(res.not_member)}개` },
                 ...(res.not_owner ? [{ k: '소속자 번호', v: `${n(res.not_owner)}개 (동의는 소유자 단위)` }] : []),
                 ...(res.bad ? [{ k: '번호 모양 아님', v: `${n(res.bad)}칸` }] : []),
             ],
             confirm: '확인',
         });
     })
     .fail(() => { restore(); $j.Ui.Dialog.open({tone:'danger', title:'서버 오류'}); });
}

/** 시간을 사람이 읽기 좋은 단위로 — 24의 배수면 '일', 아니면 '시간'. (통계 표의 열 제목에 씀) */
function formatWindowLabel(hours) {
    hours = Number(hours) || 1;
    return (hours >= 24 && hours % 24 === 0) ? `${hours / 24}일` : `${hours}시간`;
}

/** 조회기간 프리셋(당일=1 / 최근3일=3 / 일주일=7 / 한달=30) → 오늘 기준 YYYY-MM-DD 범위 */
function periodDateRange(days) {
    const fmt = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const to   = new Date();
    const from = new Date(Date.now() - (days - 1) * 86400000);
    return { from: fmt(from), to: fmt(to) };
}

function loadTable() {
    const columns = [
        {data: 'num', title: '#', width: '70px'},
        {data: 'msg_type', title: '채널', width: '60px',
            render: v => `<span class="badge-channel badge-${v}">${v}</span>`},
        {data: null, title: '용도', width: '110px',
            render: r => purposeCell(r)},
        {data: null, title: '받는번호', width: '160px',
            render: r => {
                const phone = $j.Common.Util.phoneNumber(r.to_phone || '');
                // 회원이면 `이름#번호` + 회원 팝오버 (행을 누르면 상세가 열리므로 stop)
                const who   = parseInt(r.to_mb_no) ? $j.F.Admin.Member.Pop.cell(r.to_mb_no, r.mem_name, { stop: true }) : escapeHtml(r.mem_name || '');
                const name  = r.mem_name ? ` <small class="text-muted">${who}</small>` : '';
                return `<span style="white-space:nowrap">${phone}${name}</span>`;
            }},
        {data: 'message', title: '본문',
            render: (v, _, row) => {
                const text = v || '';
                const cut  = text.length > 60 ? text.substr(0, 60) + '…' : text;
                return `<a href="#" class="cell-detail" data-ss="detail" data-n="${row.num}">${escapeHtml(cut)}</a>`;
            }},
        {data: null, title: '처리상태', width: '70px',
            render: r => statusBadge(r)},
        {data: null, title: '비즈고 응답', width: '280px', className: 'bizgo-cell',
            render: r => bizgoCell(r)},
        {data: 'manage_name', title: '관리자', width: '90px',
            render: v => v || '-'},
        {data: 'created_at', title: '발송일시', width: '160px',
            render: v => v ? $j.Common.Util.formatDateTime(v) : '-'},
        {data: 'last_seen', title: '최종 접속일', width: '160px',
            render: v => v ? $j.Common.Util.formatDateTime(v) : '<span class="text-muted">-</span>'},
    ];

    if ($table) { $table.destroy(); $('#log-table').empty(); }

    $table = new DataTable('#log-table', {
        autoWidth: false,
        columns,
        headerCallback: thead => $(thead).find('th').css('text-align', 'center'),
        ajax: {
            url: '/adm/ajax/sms-send/list',
            type: 'post',
            data: d => Object.assign(d, {
                msg_type:   $('#f_msg_type').val(),
                status:     $('#f_status').val(),
                manage_num: $('#f_manage_num').val(),
                purpose:    $('#f_purpose').val(),
                keyword:    $('#f_keyword').val(),
                date_from:  $('#f_date_from').val(),
                date_to:    $('#f_date_to').val(),
            })
        },
        language: {
            emptyTable: '데이터가 없습니다.',
            info: '_TOTAL_ 건',
            loadingRecords: '로딩 중...',
            zeroRecords: '일치하는 결과가 없습니다.',
            paginate: {previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>"}
        },
        processing: true,
        serverSide: true,
        ordering: false,
        pageLength: 25,
        lengthChange: false,
        searching: false
    });
}

function reloadTable() { $table && $table.ajax.reload(); loadRunning(); }

// ── 진행 중인 수동발송 — 남은 건수 · 다시 보내는 시각 · [중단] ──
function loadRunning() {
    $.post('/adm/ajax/sms-send/running', {}, function (res) {
        const list = (res.result && res.list) || [];
        $('#ss-running').prop('hidden', !list.length);
        $('#ss-running-list').html(list.map(r => {
            const n = (v) => Number(v || 0).toLocaleString();
            const rest = Number(r.total) - Number(r.sent) - Number(r.skipped);
            const when = r.next_at ? `${escapeHtml(String(r.next_at).substr(5, 11))}에 이어 보냅니다` : '보내는 중';
            const notes = [Number(r.failed) ? `실패 ${n(r.failed)}건` : '', Number(r.skipped) ? `수신 철회 ${n(r.skipped)}건` : ''].filter(Boolean).join(' · ');
            return `<div class="ss-run-row">
                        <div><span class="badge-channel badge-${escapeHtml(r.msg_type)}">${escapeHtml(r.msg_type)}</span>
                            <b>${n(r.sent)} / ${n(r.total)}건</b> · 남은 ${n(rest)}건 · ${when}
                            <div class="sub">${escapeHtml(r.manage_name || '시스템')} · 회차 ${escapeHtml(r.group_id)}${notes ? ' · ' + notes : ''}</div></div>
                        <button type="button" class="btn btn-sm btn-outline-danger" data-ss="cancelRun" data-n="${Number(r.num)}" data-rest="${rest}">중단</button>
                    </div>`;
        }).join(''));
    }, 'json');
}
async function cancelRun(el) {
    const rest = Number(el.dataset.rest).toLocaleString();
    const ok = await $j.Ui.Dialog.open({tone:'warn', title:`남은 ${rest}건을 보내지 않습니다`, desc:'이미 나간 건은 되돌릴 수 없고, 남은 번호는 지워집니다.', confirm:'중단', cancel:'계속 보내기'});
    if (!ok) return;
    $.post('/adm/ajax/sms-send/cancel', { num: el.dataset.n }, function (res) {
        if (!res.result) $j.Ui.Dialog.open({tone:'warn', title: res.message || '중단 실패'});
        loadRunning();
    }, 'json').fail(() => $j.Ui.Dialog.open({tone:'danger', title:'서버 오류'}));
}

function resetFilter() {
    $('#f_msg_type,#f_status,#f_manage_num,#f_purpose,#f_keyword').val('');
    $('#f_date_from').val(PAGE.weekAgo);
    $('#f_date_to').val(PAGE.today);
    reloadTable();
}

/** 문자 효과 통계 — 조회기간 프리셋 버튼만으로 고른다 (발송내역 검색조건과 무관). */
function reloadStats() {
    const days = Number($('#ss-period-group button.active').data('days')) || 7;
    const { from, to } = periodDateRange(days);

    $.post('/adm/ajax/sms-send/stats', { date_from: from, date_to: to }, renderStats, 'json')
     .fail(function () {
         $('#ss-headline').text('통계 조회 실패');
         $('#ss-win-row').html('<div class="col-12 text-danger">통계 조회 실패</div>');
     });
}

/** 상단 총정리 한 줄 — "발송 대상 N명 중 M명이 [가장 넓은 기준] 이내 접속, X%" */
function renderHeadline(s) {
    if (!s.total_members) {
        $('#ss-headline').text('선택한 기간에 발송 대상 회원이 없습니다.');
        return;
    }
    $('#ss-headline').html(
        `문자 발송 대상 <b>${s.total_members.toLocaleString()}명</b> 중 ` +
        `<b>${s.reacted_members.toLocaleString()}명</b>이 발송 후 ${formatWindowLabel(s.window_hours)} 이내 접속` +
        `<span class="ss-headline-pct">${s.rate}%</span>`
    );
}

/**
 * 유형별 반응율 — 기준(1시간~7일)마다 카드 하나, 카드 제목 오른쪽에 그 기준의 전체 접속인원.
 * 카드 안은 /adm/stat/members/current(.ms-bd)와 같은 형식의 가로 막대(막대폭·값 = 반응율 %).
 * 전부 회원 수 기준(문자 건수 아님).
 */
function renderStats(res) {
    renderHeadline(res.summary);
    const windows = res.windows;
    const rows = [{ label: '전체', isTotal: true, color: TOTAL_COLOR, ...res.total }, ...res.byPurpose.map(r => ({
        label: PURPOSE_LABELS[r.purpose] || r.purpose || '-', isTotal: false,
        color: PURPOSE_COLORS[r.purpose] || PURPOSE_COLOR_FALLBACK,
        ...r,
    }))];

    const panels = windows.map(h => {
        const bars = rows.map(r => {
            const w = r.windows[h];
            return `<div class="row-item${r.isTotal ? ' is-total' : ''}">
                        <span class="lbl" title="${escapeHtml(r.label)}">${escapeHtml(r.label)}</span>
                        <span class="bar-track"><span class="bar" style="width:${Math.max(w.rate, 2)}%;background:${r.color}"></span></span>
                        <span class="val">${w.rate}% <small>(${w.reacted_cnt.toLocaleString()}/${r.sent_cnt.toLocaleString()})</small></span>
                    </div>`;
        }).join('');
        return `<div class="col-md-4 mb-2">
                    <div class="card h-100">
                        <div class="card-header">문자발송 후 <span class="ss-window-em">${formatWindowLabel(h)}</span> 이내 접속</div>
                        <div class="card-body">${bars}</div>
                    </div>
                </div>`;
    }).join('');

    $('#ss-win-row').html(
        rows.length ? panels : '<div class="col-12 text-muted text-center py-3">데이터가 없습니다.</div>'
    );
}

function showDetail(num) {
    const row = $table.rows().data().toArray().find(r => Number(r.num) === Number(num));
    if (!row) return;
    const html = `
                <table class="table table-sm" style="font-size:12px;margin-bottom:0">
                    <tbody>
                        <tr><th width="120">#</th><td>${row.num}</td></tr>
                        <tr><th>채널</th><td><span class="badge-channel badge-${row.msg_type}">${row.msg_type}</span></td></tr>
                        <tr><th>용도</th><td>${purposeCell(row)} <small class="text-muted">(${escapeHtml(row.purpose || '-')})</small></td></tr>
                        <tr><th>group_id</th><td><small>${row.group_id || '-'}</small></td></tr>
                        <tr><th>받는번호</th><td>${$j.Common.Util.phoneNumber(row.to_phone || '')} ${row.mem_name ? '<small class="text-muted">'+(parseInt(row.to_mb_no) ? $j.F.Admin.Member.Pop.cell(row.to_mb_no, row.mem_name) : escapeHtml(row.mem_name))+'</small>' : ''}</td></tr>
                        <tr><th>발신번호</th><td>${row.from_phone ? $j.Common.Util.phoneNumber(row.from_phone) : '<span class="text-muted">-</span>'}</td></tr>
                        <tr><th>관리자</th><td>${row.manage_name || '-'}</td></tr>
                        <tr><th>처리상태</th><td>${statusBadge(row)}</td></tr>
                        ${Number(row.is_ad) === 1 ? '<tr><th>광고성</th><td>(광고) 표기 · 무료수신거부 번호 안내 · 수신동의자 한정 · 수신거부 번호 제외</td></tr>' : ''}
                        ${bizgoDetailRows(row)}
                        <tr><th>발송일시</th><td>${row.created_at || '-'}</td></tr>
                    </tbody>
                </table>
                <h6 class="mt-3">본문</h6>
                <pre class="bg-light p-2" style="max-height:300px;overflow:auto;font-size:12px;white-space:pre-wrap;word-break:break-all;margin-bottom:0">${escapeHtml(row.message || '')}</pre>
                ${mmsDetailBlock(row)}
            `;
    $j.Ui.JBModal.html('sms-send-detail', html, `문자 발송 #${row.num} (${row.msg_type})`, {width: '720px'});
}

// ── 수동발송 모달 ─────────────────────────────────────────
const SEGMENT_DICT = PAGE.segment;   // memberTypes · carTypes · bonsa{code:name} · gisa{code:name}
const AD_RULE      = PAGE.adRule;    // prefix · suffix · denyPhone
const MMS_RULE     = PAGE.mmsRule;   // maxFiles · maxBytes · lmsLimit
const LMS_BYTE_LIMIT = MMS_RULE.lmsLimit;

// 모달 하나의 상태 — 열 때마다 새로 만든다
let SM = null;

/** @param {boolean} ad true 면 광고 모드 — (광고)·무료수신거부 안내·수신동의자만이 고정. 일반 모달엔 광고 선택지가 없다 */
function openSendModal(ad = false) {
    SM = { mode: 'direct', channel: 'sms', mms: [], count: null, countTimer: null, countXhr: null, recent: null, csv: null,
           ad: !!ad };
    const html = $('#sm-modal-tmpl').html();
    $j.Ui.JBModal.html('sms-send-modal', html, ad ? '광고 문자 발송' : '문자 발송', {
        width: '940px',
        onOpen: bindSendForm,
    });
}

function bindSendForm($modal) {
    SM.$modal = $modal;
    const $msg = $modal.find('#sm_message');
    $modal.find('#sm_is_ad').prop('checked', SM.ad);
    $modal.find('#sm_ad_box').toggle(SM.ad);

    // 보내는번호 select 옵션 텍스트를 phoneNumber() 로 포매팅
    $modal.find('#sm_from_phone option').each(function () {
        const v = $(this).attr('value');
        if (v) $(this).text($j.Common.Util.phoneNumber(v));
    });

    // 직접입력 | 회원 분류 — 제목 아래 탭
    $modal.find('.sm-tabs > button').on('click', function () {
        setMode($(this).data('mode'));
    });

    // 최근 발송 — 열 때 한 번 받아두고, 버튼으로 펼친다. 목록 밖을 누르면 접힌다
    $modal.find('#sm_recent_btn').on('click', function (e) {
        e.stopPropagation();
        const $list = $modal.find('#sm_recent_list');
        if ($list.is(':visible')) { $list.hide(); return; }
        $list.show();
        if (SM.recent === null) loadRecent();
    });
    $modal.find('#sm_recent_list').on('click', '.sm-recent-item', function () {
        const r = (SM.recent || [])[$(this).index()];
        $modal.find('#sm_recent_list').hide();
        if (r) applyRecent(r);
    });
    $modal.on('click', function (e) {
        if (!$(e.target).closest('.sm-recent').length) $modal.find('#sm_recent_list').hide();
    });

    // 받는번호 — 칸 하나로 시작. [추가] 로만 칸이 늘고, [제거] 로 뺀다 (마지막 한 칸은 비우기만)
    addToRow();
    $modal.find('#sm_to_add').on('click', () => addToRow(true));
    $modal.find('#sm_to_list')
        .on('input', '.sm-to-phone', function () {
            autoFormatPhone($(this));
            $(this).closest('.sm-to-row').removeClass('is-bad');
            $modal.find('#sm_phone_hint').text('').css('color','');
            refreshFinal();
            refreshSendButton();
        })
        .on('keydown', '.sm-to-phone', function (e) {
            if (e.key === 'Enter') e.preventDefault();   // Enter 는 아무 일도 안 한다 — 칸은 [추가] 로만
        })
        .on('click', '.rm', function () {
            const $row = $(this).closest('.sm-to-row');
            if ($modal.find('#sm_to_list .sm-to-row').length > 1) $row.remove();
            else $row.find('.sm-to-phone').val('010');
            focusToRow($modal.find('#sm_to_list .sm-to-phone').last());   // 빼고 나서 바로 이어 칠 수 있게
            refreshFinal();
            refreshSendButton();
        });
    $msg.on('input', refreshCompose);

    // CSV — 고르면 서버가 읽어 번호와 건수를 돌려준다 (파일은 남지 않는다)
    $modal.find('#sm_csv_btn').on('click', () => $modal.find('#sm_csv_file').trigger('click'));
    $modal.find('#sm_csv_file').on('change', onCsvPicked);

    // 분류 칩 4개 — 게시판 글 대상자와 같은 어휘. 회원유형은 「전체」도 고르는 값이다(비어 있으면 아직 안 고른 것)
    const toDict = arr => { const d = {}; (arr || []).forEach(v => d[v] = v); return d; };
    setupChip('mtype', toDict(SEGMENT_DICT.memberTypes), { all: '전체 · 유형 상관없이' });
    setupChip('ctype', toDict(SEGMENT_DICT.carTypes),    { all: '전체 · 장비 상관없이' });
    setupChip('bonsa', SEGMENT_DICT.bonsa || {},            { all: '전체 · 본사 상관없이' });
    setupChip('gisa',  SEGMENT_DICT.gisa  || {},            { all: '전체 · 지사 상관없이' });
    $modal.find('#sm_include_sosok').on('change', function () { refreshCountBox(); scheduleCount(); });
    $modal.find('#sm_reset').on('click', resetRecipient);

    // 미리보기 ↔ 입력 — 오른쪽 카드 자리를 바꾼다
    $modal.find('#sm_preview_btn').on('click', () => showPreview(true));
    $modal.find('#sm_edit_btn').on('click', () => showPreview(false));

    // 보내는 방식 — 문자 | RCS
    $modal.find('.sm-channel button').on('click', function () {
        setChannel($(this).data('channel'));
    });

    // MMS 이미지
    $modal.find('#sm_mms_add').on('click', () => $modal.find('#sm_mms_file').trigger('click'));
    $modal.find('#sm_mms_file').on('change', onMmsFilesPicked);
    $modal.find('#sm_mms_grid')
        .on('click', '.rm', function (e) {
            e.stopPropagation();
            SM.mms.splice($(this).closest('.sm-mms-thumb').index(), 1);
            renderMms();
            refreshCompose();
        })
        // 썸네일을 누르면 크게 — 붙인 이미지 전부를 넘겨 보며 확인한다
        .on('click', '.sm-mms-thumb.has-img', function () {
            const items = SM.mms.filter(f => f.url).map(f => ({
                url: f.url, caption: f.name || '',
                meta: [f.width ? `${f.width}×${f.height}` : '', f.bytes ? Math.round(f.bytes / 1024) + 'KB' : ''].filter(Boolean).join(' · '),
            }));
            const url = $(this).data('url');
            $j.Ui.ZoomPhoto.open(null, { items, index: Math.max(0, items.findIndex(i => i.url === url)), size: 'fit', loop: false, maxWidth: 900 });
        });

    // RCS 버튼
    $modal.find('#sm_btn_add').on('click', () => { addButtonRow(); refreshButtons(); });
    $modal.find('#sm_btn_list')
        .on('click', '.rm', function () { $(this).closest('.sm-btn-row').remove(); refreshButtons(); })
        .on('change', '[data-k="type"]', function () {
            $(this).closest('.sm-btn-row').find('[data-k="value"]')
                .attr('placeholder', $(this).val() === 'tel' ? '전화번호 (예: 1600-0421)' : 'https://');
        });

    $modal.find('.sm-send-btn').on('click', doSend);

    refreshCompose();
    refreshFinal();
    setTimeout(() => focusToRow(SM.$modal.find('#sm_to_list .sm-to-phone').first()), 50);
}

/** 받는번호 칸을 하나 더 — 010 이 들어 있고 커서는 그 뒤. focus 면 바로 칠 수 있게 포커스까지 */
function addToRow(focus = false, value = '010') {
    const $row = $(`<div class="sm-to-row">
                <input type="tel" class="form-control sm-to-phone" placeholder="010-0000-0000" maxlength="13" autocomplete="off">
                <button type="button" class="btn btn-outline-danger rm" title="이 칸을 뺍니다">제거</button>
            </div>`);
    $row.find('.sm-to-phone').val(value);
    SM.$modal.find('#sm_to_list').append($row);
    if (focus) focusToRow($row.find('.sm-to-phone'));
    return $row;
}
function focusToRow($input) {
    const el = $input.trigger('focus')[0];
    if (el && el.setSelectionRange) el.setSelectionRange(el.value.length, el.value.length);
}
/** 칸마다 숫자만 — 010 만 있거나 빈 칸은 '안 쓴 칸'이라 뺀다. 같은 번호는 한 번만 */
function toPhones() {
    const out = [];
    SM.$modal.find('#sm_to_list .sm-to-phone').each(function () {
        const d = String($(this).val()).replace(/\D/g, '');
        if (d.length >= 9 && !out.includes(d)) out.push(d);
    });
    return out;
}
/** 치다 만 칸(1~8자리, 010 만 남은 칸은 제외) — 발송 전에 잡는다 */
function badToRow() {
    let $bad = null;
    SM.$modal.find('#sm_to_list .sm-to-phone').each(function () {
        const d = String($(this).val()).replace(/\D/g, '');
        if (d && d !== '010' && d.length < 9 && !$bad) $bad = $(this);
    });
    return $bad;
}

function onCsvPicked() {
    const file = this.files && this.files[0];
    this.value = '';
    if (!file) return;
    const $m = SM.$modal;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('is_ad', SM.ad ? 1 : 0);
    SM.csv = null;
    $m.find('#sm_csv_result').prop('hidden', false).html('<i class="fa fa-spinner fa-spin"></i> 읽는 중…');
    refreshFinal();
    $.ajax({ url: '/adm/ajax/sms-send/csv-parse', method: 'POST', data: fd, processData: false, contentType: false, dataType: 'json' })
     .done(res => {
         if (!res.result) { $m.find('#sm_csv_result').prop('hidden', true); $j.Ui.Dialog.open({tone:'warn', title: res.message || 'CSV 읽기 실패'}); return; }
         SM.csv = { name: file.name, phones: res.phones };
         const n = (v) => Number(v || 0).toLocaleString();
         const parts = [`읽은 칸 ${n(res.read)}`];
         if (res.duplicate) parts.push(`중복 ${n(res.duplicate)}`);
         if (res.bad) parts.push(`번호 아님 ${n(res.bad)}`);
         if (res.excluded) parts.push(`광고 동의 없음 ${n(res.excluded)}`);
         $m.find('#sm_csv_result').text('').append($('<div></div>').text(file.name), $('<b></b>').text(`발송 대상 ${n(res.phones.length)}명`), $('<div class="sub"></div>').text(parts.join(' · ')));
         refreshFinal();
     })
     .fail(() => { $m.find('#sm_csv_result').prop('hidden', true); $j.Ui.Dialog.open({tone:'danger', title:'CSV 읽기 중 서버 오류'}); });
}

/** 받는사람 조건을 모두 비운다 — 번호·칩·소속자 포함. 본문·이미지는 그대로 */
function resetRecipient() {
    const $m = SM.$modal;
    $m.find('#sm_to_list').empty();
    addToRow();
    $m.find('#sm_phone_hint').text('').css('color', '');
    SM.csv = null;
    $m.find('#sm_csv_result').prop('hidden', true).empty();
    ['mtype', 'ctype', 'bonsa', 'gisa'].forEach(w => { $m.find(`#sm_chips_${w}`).empty(); updateChipEmpty(w); $m.find(`#sm_picker_${w}`).val(''); });
    syncSegmentBoxes();
    $m.find('#sm_include_sosok').prop('checked', false);
    SM.count = null;
    $m.find('#sm_count_n, #sm_count_ad, #sm_count_no, #sm_final_n').text('-');
    refreshCountBox();
    if (SM.mode === 'segment') scheduleCount(0);
    refreshSendButton();
}

function setMode(mode) {
    SM.mode = mode;
    const $m = SM.$modal;
    $m.find('.sm-tabs > button').removeClass('active').filter(`[data-mode="${mode}"]`).addClass('active');
    $m.find('.sm-pane').hide().filter(`[data-pane="${mode}"]`).show();
    if (mode === 'segment' && SM.count === null) scheduleCount(0);
    refreshCountBox();   // 요약표(회원유형 '선택 안 함' 포함)·발송 대상·버튼
}

/**
 * 보내는 방식 전환. RCS 는 이미지 1장이고 RCS 용으로 따로 올린 것(media)만 쓸 수 있어서,
 * 문자로 붙인 이미지가 있으면 비운다 (RCS → 문자는 MMS 키가 같이 있어 그대로 둔다).
 */
function setChannel(channel) {
    if (channel === 'rcs' && !MMS_RULE.rcsEnabled) {
        $j.Ui.Dialog.open({tone:'warn', title:'RCS 를 쓸 수 없습니다.', desc:'RCS 브랜드키(.env BIZGO_RCS_BRAND_KEY)가 설정되지 않았습니다.'});
        return;
    }
    if (channel === SM.channel) return;
    const $m = SM.$modal;
    if (channel === 'rcs' && SM.mms.length) {
        SM.mms = [];
        $j.Ui.Toast.show('RCS 는 이미지를 따로 올려야 해서 붙인 이미지를 비웠습니다. 다시 올려주세요.', {type: 'warning'});
    }
    SM.channel = channel;
    schedulePlan();
    $m.find('.sm-channel button').each(function () {
        const on = $(this).data('channel') === channel;
        $(this).toggleClass('btn-primary', on).toggleClass('btn-outline-secondary', !on);
    });
    $m.find('#sm_channel_note').text(channel === 'rcs'
        ? `RCS — 이미지 ${MMS_RULE.rcsMaxFiles}장 · 본문 ${MMS_RULE.rcsTextLimit.toLocaleString()}자. RCS 를 못 받는 폰엔 같은 내용의 문자로 갑니다`
        : 'SMS·LMS·MMS — 본문 길이와 이미지로 자동');
    $m.find('#sm_mms_max').text(maxFiles());
    // RCS 는 대화방 번호 하나로만 나간다 — 목록 대신 고정 번호를 보여준다
    const rcs = channel === 'rcs';
    $m.find('#sm_from_phone').toggle(!rcs);
    $m.find('#sm_from_rcs').prop('hidden', !rcs).val($j.Common.Util.phoneNumber(MMS_RULE.rcsSender));
    $m.find('#sm_from_note').text(rcs ? 'RCS 는 대화방 번호로 고정됩니다' : '목록 관리: /adm/config — "문자 보내는번호 목록"');
    renderMms();
    refreshCompose();
}
// ── RCS 버튼 — 웹링크·전화. 글이면 3개, 이미지면 2개 (짧은 글에 2개 이상이면 서버가 LMS 서식으로 보낸다) ──
function addButtonRow() {
    const $row = $(`<div class="sm-btn-row">
                <select class="form-control form-control-sm" data-k="type"><option value="url">웹링크</option><option value="tel">전화</option></select>
                <input type="text" class="form-control form-control-sm" data-k="label" maxlength="${MMS_RULE.rcsButtonLabel}" placeholder="버튼명">
                <button type="button" class="btn btn-sm btn-outline-secondary rm" title="빼기">×</button>
                <input type="text" class="form-control form-control-sm" data-k="value" placeholder="https://">
            </div>`);
    SM.$modal.find('#sm_btn_list').append($row);
    $row.find('[data-k="label"]').trigger('focus');
}
function buttonsMax() {
    const max = MMS_RULE.rcsButtonsMax;
    return SM.mms.length ? max.image : max.lms;
}
/** 채운 버튼만 — 버튼명·값 둘 다 빈 줄은 뺀다 */
function collectButtons() {
    const out = [];
    SM.$modal.find('#sm_btn_list .sm-btn-row').each(function () {
        const b = {};
        $(this).find('[data-k]').each(function () { b[$(this).data('k')] = String($(this).val()).trim(); });
        if (b.label || b.value) out.push(b);
    });
    return out;
}
function refreshButtons() {
    const $m = SM.$modal;
    const rcs = SM.channel === 'rcs';
    $m.find('#sm_rcs_btn_box').toggle(rcs);
    if (!rcs) return;
    const max = buttonsMax();
    const n = $m.find('#sm_btn_list .sm-btn-row').length;
    $m.find('#sm_btn_max').text(max).css('color', n > max ? 'var(--adm-c-dc3545, #dc3545)' : '');
    $m.find('#sm_btn_add').toggle(n < max);
}

function maxFiles() {
    return SM.channel === 'rcs' ? MMS_RULE.rcsMaxFiles : MMS_RULE.maxFiles;
}
/** 화면에 보일 채널 — RCS 거나, 이미지·바이트로 SMS/LMS/MMS */
function msgType() {
    if (SM.channel === 'rcs') return 'RCS';
    return SM.mms.length ? 'MMS' : (eucKrBytes(composedMessage()) <= SMS_BYTE_LIMIT ? 'SMS' : 'LMS');
}

function autoFormatPhone($input) {
    let v = String($input.val()).replace(/[^0-9]/g, '');
    if (v.length > 11) v = v.substr(0, 11);
    $input.val($j.Common.Util.phoneNumber(v));
}

/**
 * 발송 대상 카드 — 직접입력이면 추가한 번호 수. 회원 분류면 1줄 「발송 대상 N명 · 조건 일치 N명」, 2줄 「수신동의 N · 미동의 N」.
 * 광고는 수신동의자에게만 가므로 광고 모드의 발송 대상 = 수신동의. 일반 모드는 조건 일치 전부가 발송 대상이다.
 */
function refreshFinal() {
    drawFinal();
    schedulePlan();
}
function drawFinal() {
    const $m = SM.$modal;
    const direct = SM.mode === 'direct';
    $m.find('#sm_final_direct').prop('hidden', !direct);
    $m.find('#sm_final_seg, #sm_final_match').prop('hidden', SM.mode !== 'segment');
    const isAd = $m.find('#sm_is_ad').is(':checked');
    if (SM.mode === 'csv') {
        $m.find('#sm_final_n').text(SM.csv ? SM.csv.phones.length.toLocaleString() : '-');
        return;
    }
    if (direct) {
        const n = toPhones().length;
        $m.find('#sm_final_n').text(n ? String(n) : '-');
        $m.find('#sm_final_direct').prop('hidden', !!n);   // 번호가 있으면 인원만 — 번호는 위 칸에 이미 보인다
        return;
    }
    if (SM.count) {
        $m.find('#sm_count_n').text(SM.count.all.toLocaleString());
        $m.find('#sm_count_ad').text(SM.count.ad.toLocaleString());
        $m.find('#sm_count_no').text(Math.max(0, SM.count.all - SM.count.ad).toLocaleString());
        $m.find('#sm_final_n').text((isAd ? SM.count.ad : SM.count.all).toLocaleString());
    } else {
        $m.find('#sm_count_n, #sm_count_ad, #sm_count_no, #sm_final_n').text('-');
    }
}

// ── 발송 일정 — 몇 번에 나눠 가는지, 오늘 몇 건이고 남은 건 언제 가는지. 계산은 서버(SmsSendService::planSchedule) 한 곳 ──
const PLAN_DEFAULT_NOTE = () => `${MMS_RULE.limitPerSend.toLocaleString()}건씩 묶어 보내고, 전 채널 합계가 하루 ${MMS_RULE.limitPerDay.toLocaleString()}건(RCS 는 ${MMS_RULE.limitPerDayRcs.toLocaleString()}건)·한 달 ${MMS_RULE.limitPerMonth.toLocaleString()}건에 닿으면 멈췄다가 오전 8시에 이어 보냅니다`;
const num = (v) => Number(v || 0).toLocaleString();

/** 지금 화면의 받는 사람 수 — 아직 모르면 null */
function targetCount() {
    if (SM.mode === 'csv') return SM.csv ? SM.csv.phones.length : null;
    if (SM.mode === 'direct') return toPhones().length || null;
    return effectiveCount();
}
function schedulePlan() {
    clearTimeout(SM.planTimer);
    SM.planTimer = setTimeout(loadPlan, 200);
}
function loadPlan() {
    const n = targetCount();
    if (!n) { SM.planKey = null; renderPlan(null); return; }
    const key = `${SM.channel}:${n}`;   // RCS 와 문자는 하루 한도가 달라 일정도 다르다
    if (SM.planKey === key) return;
    SM.planKey = key;
    fetchPlan(n).then(plan => { if (SM && SM.planKey === key) renderPlan(plan); }).catch(() => { if (SM) SM.planKey = null; });
}
function fetchPlan(n) {
    return new Promise((ok, fail) => {
        $.post('/adm/ajax/sms-send/plan', { count: n, channel: SM.channel }, res => (res.result ? ok(res.plan) : fail()), 'json').fail(fail);
    });
}
/** 첫 날 다음으로 밀리는가 — 오늘 안에 다 못 나간다 */
function planSpills(plan) { return plan.days.length > 1 || !plan.days[0].today; }
/** 오늘 안에 끝나는 발송의 한 줄 — 나눠 보내는 횟수 */
function planTodayLine(plan) {
    return plan.batches > 1
        ? `${plan.batches}번에 나눠 보냅니다 (${num(plan.batch_size)}건씩)`
        : '한 번에 보냅니다';
}
/** 밀리는 발송의 제목 — 오늘 n건만 / 오늘은 못 나감 */
function planHeadline(plan) {
    const first = plan.days[0];
    return first.today ? `오늘은 ${num(first.count)}건만 나갑니다` : '오늘은 나가지 않습니다';
}
/** 날짜를 굵게 — 화면에 넣는 문장·줄에 쓴다 (알림 토스트는 글자만) */
const planDate = (label) => `<strong class="sm-plan-date">${escapeHtml(label)}</strong>`;
/**
 * 남은 건이 언제 가는지 한 문장
 * @param {function} [mark] 날짜 글자를 감싸는 함수 — 주면 결과는 HTML 이다
 */
function planRestLine(plan, mark = (v) => v) {
    const first = plan.days[0];
    if (first.today && plan.days.length === 1) return '';
    const rest = first.today ? plan.count - first.count : plan.count;
    const start = first.today ? plan.days[1] : first;
    const last = plan.days[plan.days.length - 1];
    const head = `${first.today ? '남은 ' : ''}${num(rest)}건은 ${mark(start.label)} 오전 8시`;
    return last === start ? `${head}에 보낼 예정입니다.` : `${head}부터 보내고, ${mark(last.label)}에 끝날 예정입니다.`;
}
/** 다음 달로 넘어갈 때의 경고 한 문장 — 없으면 '' */
function planMonthLine(plan) {
    if (!plan.next_month_count) return '';
    const hold = plan.month_hold ? `이번 달 한도 ${num(MMS_RULE.limitPerMonth)}건에 닿아 ${plan.month_hold}까지 멈춥니다. ` : '';
    return `${hold}${num(plan.next_month_count)}건이 다음 달로 넘어갑니다. 본문의 날짜·이달 혜택이 그때도 맞는지 확인하세요.`;
}
/** 일반 문자가 자동 문자 몫까지 쓸 때의 경고 한 문장 — 없으면 '' */
function planAutoLine(plan) {
    if (!plan || !plan.uses_auto_quota) return '';
    return `하루 합계 ${num(MMS_RULE.limitPerDayRcs)}건을 넘어 자동 문자 몫까지 소진됩니다. ${num(MMS_RULE.limitPerDay)}건에 닿으면 그날 남은 매칭·세금 같은 자동 문자는 거절되고 다시 보내지 않습니다.`;
}
function renderPlan(plan) {
    const $plan = SM.$modal.find('#sm_plan').removeClass('is-warn is-danger');
    if (!plan || !plan.days.length) { $plan.text(PLAN_DEFAULT_NOTE()); return; }
    const auto = planAutoLine(plan);
    if (!planSpills(plan)) {
        $plan.text(`${planTodayLine(plan)} · 오늘 남은 한도 ${num(plan.today_rest)}건${plan.ahead ? ` (진행 중인 발송 ${num(plan.ahead)}건 제외)` : ''}`);
        if (auto) $plan.addClass('is-warn').append($('<div class="note"></div>').text(auto));
        return;
    }
    const month = planMonthLine(plan);
    $plan.addClass(month ? 'is-danger' : 'is-warn').empty()
        .append($('<b></b>').text(planHeadline(plan)))
        .append($('<div></div>').html(planRestLine(plan, planDate)));
    const $ul = $('<ul></ul>');
    planRows(plan).forEach(r => $ul.append($('<li></li>').append($('<span></span>').text(r.k), $('<span></span>').text(r.v))));
    $plan.append($ul);
    if (month) $plan.append($('<div class="note"></div>').text(month));
    if (auto) $plan.append($('<div class="note"></div>').text(auto));
}
/** 날짜별 건수 줄 — 길면 앞 네 줄과 마지막 줄만. 모달 안내와 확인창이 같이 쓴다 */
function planRows(plan) {
    const rows = plan.days.map(d => ({ k: (d.today ? '오늘 ' : '') + d.label, v: `${num(d.count)}건`, tone: d.next_month ? 'danger' : undefined }));
    if (rows.length <= 5) return rows;
    return [...rows.slice(0, 4), { k: '…', v: `${rows.length - 5}일 더`, weak: true }, rows[rows.length - 1]];
}
/** 확인창 위쪽 — 언제 가는지 문장 · 다음 달 경고 · 날짜별 건수. 날짜를 굵게 하려고 Dialog 의 html 슬롯에 같은 모양으로 그린다 */
function planDialogHtml(plan, month, auto) {
    const days = planRows(plan).map(r => `<div class="ui-dlg__row${r.weak ? ' is-weak' : ''}">
            <dt${r.weak ? '' : ' class="sm-plan-date"'}>${escapeHtml(r.k)}</dt><dd class="${r.tone ? 'is-' + r.tone : ''}">${escapeHtml(r.v)}</dd></div>`).join('');
    return `<p class="ui-dlg__desc">${planRestLine(plan, planDate)} 등록하면 되돌릴 수 없고, 건수만큼 요금이 나갑니다.</p>
            ${month ? `<p class="ui-dlg__emph">${escapeHtml(month)}</p>` : ''}
            ${auto ? `<p class="ui-dlg__emph">${escapeHtml(auto)}</p>` : ''}
            <dl class="ui-dlg__rows">${days}</dl>`;
}
/**
 * 발송 확인창 — 일정이 밀리면 제목부터 그 얘기를 한다. 등록 직전에 일정을 다시 받아 그 숫자로 보여 준다.
 * @param {number} n 받는 사람 수
 * @param {string} title 평소 제목 ('N명에게 LMS 문자를 보냅니다')
 * @param {object[]} rows 받는 사람·채널·광고성 줄
 * @return {Promise<boolean>}
 */
async function confirmSend(n, title, rows) {
    let plan = null;
    try { plan = await fetchPlan(n); } catch (e) { /* 일정을 못 받아도 발송은 막지 않는다 — 아래 일반 문구로 */ }
    const spills = !!plan && plan.days.length > 0 && planSpills(plan);
    const month  = spills ? planMonthLine(plan) : '';
    const auto   = planAutoLine(plan);
    const hints  = [];
    if (spills) hints.push('앞으로의 자동 문자도 같은 한도를 쓰므로 날짜가 밀릴 수 있습니다. 남은 건은 발송내역의 진행 카드에서 중단할 수 있습니다.');
    if (spills && SM.ad) hints.push('광고는 보내기 직전 수신 동의를 다시 확인하므로 그사이 철회한 회원은 빠집니다.');
    return $j.Ui.Dialog.open({
        tone: month ? 'danger' : 'warn', align: 'left',
        title: spills ? `${title} — ${planHeadline(plan)}` : title,
        desc: spills ? undefined : `등록하면 되돌릴 수 없습니다. 건수만큼 요금이 나갑니다.${plan && plan.batches > 1 ? ` ${planTodayLine(plan)}.` : ''}`,
        emph: !spills && auto ? auto : undefined,
        html: spills ? planDialogHtml(plan, month, auto) : undefined,
        rows,
        hint: hints.join(' ') || undefined,
        confirm: '발송', cancel: '취소',
    });
}

// ── 칩 (post-edit 의 chip-multiselect 와 같은 동작, id 만 sm_ 접두) ──
const ALL = '*';   // 고르기의 「전체」 항목 값 — 기본값이 아니라 고르는 값. 단독 칩이고 서버에는 그 축 빈 배열(=조건 없음)로 간다
/** 축의 실제 조건값 — 「전체」 칩은 뺀다 */
function axisCodes(wId) { return chipCodes(wId).filter(c => c !== ALL); }
/** 회원유형 「전체」를 골랐는가 */
function mtypeAll() { return chipCodes('mtype').includes(ALL); }
/** 회원유형을 골랐는가(유형 칩 또는 전체) — 안 골랐으면 인원도 안 세고 발송도 막는다 */
function mtypeChosen() { return mtypeAll() || chipCodes('mtype').length > 0; }
/** 서버에 보낼 회원유형 — 「전체」면 빈 배열 */
function mtypeCodes() { return axisCodes('mtype'); }
/**
 * 회원유형에 따라 아래 축을 보이고 감춘다 — 장비종류는 수발주자, 본사·지사는 업체발주자를 골랐을 때만.
 * 감출 때는 그 축의 칩도 비운다(안 보이는 조건이 발송에 끼지 않게). 요약표 줄도 같이 간다.
 */
function syncSegmentBoxes() {
    const $m = SM.$modal;
    const mt = chipCodes('mtype');
    const show = { ctype: mt.includes('수발주자'), bonsa: mt.includes('업체발주자'), gisa: mt.includes('업체발주자') };
    Object.keys(show).forEach(w => {
        $m.find(`#sm_box_${w}`).prop('hidden', !show[w]);
        if (!show[w] && $m.find(`#sm_chips_${w} .chip`).length) { $m.find(`#sm_chips_${w}`).empty(); updateChipEmpty(w); }
    });
    $m.find('#sm_sumrow_ctype').prop('hidden', !show.ctype);
    $m.find('#sm_sumrow_sosok').prop('hidden', !show.bonsa);
}
/**
 * @param {object} [opt] all: 「전체」 항목 글 — 있으면 맨 위에 두고 선 하나(고를 수 없는 항목)로 아래 항목과 가른다
 */
function setupChip(wId, dict, opt = {}) {
    const $m = SM.$modal;
    const $sel = $m.find(`#sm_picker_${wId}`);
    $sel.empty().append('<option value="">+ 고르기</option>');
    if (opt.all) {
        $sel.append(`<option value="${ALL}" class="opt-all">${escapeHtml(opt.all)}</option>`);
        $sel.append('<option disabled class="opt-sep">──────────</option>');
    }
    Object.keys(dict).forEach(code => {
        $sel.append(`<option value="${escapeHtml(code)}">${escapeHtml(dict[code])}</option>`);
    });
    $sel.on('change', function () {           // 고르면 바로 칩이 된다
        const code = $(this).val();
        if (!code) return;
        addChip(wId, code, code === ALL ? '전체' : (dict[code] || code));
        $(this).val('');
    });
    $m.find(`#sm_chips_${wId}`).on('click', '.close', function () {
        $(this).closest('.chip').remove();
        updateChipEmpty(wId);
        if (wId === 'mtype') syncSegmentBoxes();
        refreshCountBox();
        scheduleCount();
    });
    updateChipEmpty(wId);
}
function addChip(wId, code, label) {
    const $chips = SM.$modal.find(`#sm_chips_${wId}`);
    if ($chips.find('.chip').filter((_, el) => $(el).data('code') === code).length) return;
    // 「전체」는 단독 — 전체를 고르면 그 축의 칩을 비우고, 다른 걸 고르면 전체 칩이 빠진다
    if (code === ALL) $chips.find('.chip').remove();
    else $chips.find('.chip').filter((_, el) => $(el).data('code') === ALL).remove();
    $chips.prop('hidden', false);
    $chips.append($(`<span class="chip${code === ALL ? ' chip-all' : ''}"><span class="lbl"></span><span class="close" title="빼기"><i class="fa fa-times"></i></span></span>`)
        .attr('data-code', code).find('.lbl').text(label).end());
    if (wId === 'mtype') syncSegmentBoxes();
    refreshCountBox();
    scheduleCount();
}
/** 칩 칸 — 칩이 하나도 없으면 칸을 감춘다(안내 문구를 두지 않는다. 고르기가 바로 위에 있다) */
function updateChipEmpty(wId) {
    const $chips = SM.$modal.find(`#sm_chips_${wId}`);
    $chips.prop('hidden', !$chips.find('.chip').length);
}
function chipCodes(wId) {
    return SM.$modal.find(`#sm_chips_${wId} .chip`).map((_, el) => String($(el).data('code'))).get();
}
function segmentPayload() {
    return {
        member_type:   mtypeCodes(),
        car_type:      axisCodes('ctype'),
        sosok:         axisCodes('bonsa').concat(axisCodes('gisa')),
        include_sosok: SM.$modal.find('#sm_include_sosok').is(':checked') ? 1 : 0,
    };
}
function segmentSummary() {
    return segmentSummaryOf(segmentPayload());
}
/** 분류 조건 → 한 줄. 확인창과 「최근 발송」목록이 같이 쓴다 */
function segmentSummaryOf(seg) {
    const parts = [];
    const mt = seg.member_type || [], ct = seg.car_type || [], so = seg.sosok || [];
    if (mt.length) parts.push(mt.join('·'));
    if (ct.length) parts.push(ct.join('·'));
    const sosok = so.map(c => SEGMENT_DICT.bonsa[c] || SEGMENT_DICT.gisa[c] || c);
    if (sosok.length) parts.push(sosok.join('·'));
    if (!parts.length) parts.push('전체 회원');
    parts.push(seg.include_sosok ? '소속자 포함' : '소유자만');
    return parts.join(' / ');
}
/** 조건 요약 표 — 축마다 고른 것, 비우면 '전체' */
function refreshSummary() {
    const $m = SM.$modal;
    const put = (id, arr, empty) => {
        const $td = $m.find('#' + id);
        if (arr.length) $td.text(arr.join(' · ')).removeClass('is-all');
        else $td.text(empty).addClass('is-all');
    };
    put('sm_sum_mtype', mtypeAll() ? ['전체'] : chipCodes('mtype'), '선택 안 함');
    put('sm_sum_ctype', chipCodes('ctype').includes(ALL) ? ['전체'] : chipCodes('ctype'), '제한 없음');
    put('sm_sum_sosok', chipCodes('bonsa').map(c => c === ALL ? '본사 전체' : (SEGMENT_DICT.bonsa[c] || c)).concat(chipCodes('gisa').map(c => c === ALL ? '지사 전체' : (SEGMENT_DICT.gisa[c] || c))), '제한 없음');
}

// ── 대상 인원 — 조건이 바뀌면 잠깐 기다렸다 한 번만 센다 ──
function scheduleCount(delay = 300) {
    clearTimeout(SM.countTimer);
    SM.countTimer = setTimeout(fetchCount, delay);
}
function fetchCount() {
    const $m = SM.$modal;
    if (SM.countXhr) SM.countXhr.abort();
    if (!mtypeChosen()) {   // 회원유형을 안 골랐으면 세지 않는다 — 발송 대상 카드는 '-'
        SM.count = null;
        $m.find('.sm-count-spin').prop('hidden', true);
        $m.find('#sm_count_n, #sm_count_ad, #sm_count_no, #sm_final_n').text('-');
        schedulePlan();
        refreshSendButton();
        return;
    }
    $m.find('.sm-count-spin').prop('hidden', false);
    SM.countXhr = $.post('/adm/ajax/sms-send/target-count', { segment: segmentPayload() }, function (res) {
        $m.find('.sm-count-spin').prop('hidden', true);
        if (!res.result) { SM.count = null; $m.find('#sm_count_n, #sm_count_ad, #sm_count_no').text('?'); return; }
        SM.count = { all: res.count, ad: res.count_ad };
        refreshCountBox();
        refreshSendButton();
    }, 'json').fail(function (xhr) {
        if (xhr.statusText === 'abort') return;
        $m.find('.sm-count-spin').prop('hidden', true);
        SM.count = null;
        $m.find('#sm_count_n, #sm_count_ad, #sm_count_no').text('?');
    });
}
function refreshCountBox() {
    refreshSummary();
    refreshFinal();
    refreshSendButton();
}
function effectiveCount() {
    if (!SM.count) return null;
    return SM.$modal.find('#sm_is_ad').is(':checked') ? SM.count.ad : SM.count.all;
}
/** 발송 버튼 — 인원은 왼쪽 발송 대상 카드가 보여 주므로 문구는 늘 '발송'. 분류 인원을 세는 동안만 알린다 */
function refreshSendButton() {
    const $btn = SM.$modal.find('.sm-send-btn');
    if ($btn.prop('disabled')) return;
    const counting = SM.mode === 'segment' && mtypeChosen() && effectiveCount() === null;
    $btn.html(`<i class="fa fa-paper-plane"></i> ${counting ? '대상 세는 중…' : '발송'}`);
}

// ── 본문 합성 (광고 접두) + 바이트·채널 배지 ──
function composedMessage() {
    const $m = SM.$modal;
    let msg = String($m.find('#sm_message').val()).trim();
    if ($m.find('#sm_is_ad').is(':checked')) {
        // 서버(SmsSendService::composeAdMessage)와 같은 규칙 — 앞 (광고), 끝 「무료수신거부 080-…」 한 줄
        if (!msg.startsWith(AD_RULE.prefix)) msg = AD_RULE.prefix + msg;
        if (!msg.endsWith(AD_RULE.suffix.trim())) msg += AD_RULE.suffix;
    }
    return msg;
}
function refreshCompose() {
    const $m = SM.$modal;
    const msg = composedMessage();
    const bytes = eucKrBytes(msg);
    const isAd = $m.find('#sm_is_ad').is(':checked');

    const type = msgType();
    const limit = type === 'SMS' ? SMS_BYTE_LIMIT : LMS_BYTE_LIMIT;
    $m.find('#sm_byte_count').text(bytes).css('color', bytes > LMS_BYTE_LIMIT ? 'var(--adm-c-dc3545, #dc3545)' : '');
    $m.find('#sm_byte_limit').text(limit.toLocaleString());
    if (type === 'RCS') {
        const over = msg.length > MMS_RULE.rcsTextLimit;
        $m.find('#sm_byte_note').html(`— RCS <span style="${over ? 'color:var(--adm-c-dc3545, #dc3545)' : ''}">${msg.length.toLocaleString()}자 / ${MMS_RULE.rcsTextLimit.toLocaleString()}자</span>`);
    } else {
        $m.find('#sm_byte_note').text(type === 'SMS' ? '— 초과 시 LMS 자동 전환' : (type === 'MMS' ? '— 이미지 첨부' : '— 장문'));
    }
    $m.find('#sm_msg_type_badge').text(type).removeClass('badge-SMS badge-LMS badge-MMS badge-RCS').addClass('badge-' + type);
    refreshButtons();
    if (!$m.find('#sm_preview').prop('hidden')) renderPreview();
}

// ── 미리보기 — 받는 폰에 보이는 모양. 입력 카드와 자리를 바꾼다 ──
function showPreview(on) {
    const $m = SM.$modal;
    $m.find('#sm_compose').prop('hidden', on);
    $m.find('#sm_preview').prop('hidden', !on);
    if (on) renderPreview();
    refreshSendButton();
}
function renderPreview() {
    const $m   = SM.$modal;
    const msg  = composedMessage();
    const type = msgType();
    const from = SM.channel === 'rcs' ? MMS_RULE.rcsSender : $m.find('#sm_from_phone').val();
    const now  = new Date();
    const hh = now.getHours(), mm = String(now.getMinutes()).padStart(2, '0');
    const ampm = `${hh < 12 ? '오전' : '오후'} ${hh % 12 || 12}:${mm}`;
    $m.find('#pv_clock').text(`${hh}:${mm}`);
    $m.find('#pv_from').text(from ? $j.Common.Util.phoneNumber(from) : '보내는번호');
    $m.find('#pv_type').text(type).removeClass('badge-SMS badge-LMS badge-MMS badge-RCS').addClass('badge-' + type);

    const $th = $m.find('#pv_thread').empty();
    $th.append(`<div class="pv-date">${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일</div>`);
    SM.mms.forEach(f => {
        if (f.url) $th.append($('<div class="pv-bubble pv-img"><img alt=""></div>').find('img').attr('src', f.url).end());
        else $th.append('<div class="pv-bubble pv-img"><div class="pv-img-ph"><i class="fa fa-image fa-2x"></i></div></div>');
    });
    const buttons = SM.channel === 'rcs' ? collectButtons().filter(b => b.label) : [];
    if (msg) $th.append($('<div class="pv-bubble"></div>').text(msg));
    else $th.append('<div class="pv-bubble pv-empty">메시지를 입력하면 여기에 보입니다</div>');
    if (buttons.length) {
        const $b = $('<div class="pv-btns"></div>');
        buttons.forEach(b => $b.append($('<span></span>').text(b.label)));
        $th.append($b);
    }
    $th.append(`<span class="pv-time">${ampm}</span>`);
}

function eucKrBytes(text) {
    // EUC-KR 근사: 한글 2바이트, 그 외 1바이트 (서버 판정은 iconv)
    let bytes = 0;
    for (let i = 0; i < text.length; i++) bytes += text.charCodeAt(i) > 0x7f ? 2 : 1;
    return bytes;
}

// ── MMS 이미지 — 고르면 바로 서버가 jpg 300KB 로 줄여 비즈고에 올리고 fileKey 를 돌려준다 ──
function onMmsFilesPicked() {
    const input = this;
    const files = Array.from(input.files || []);
    input.value = '';
    if (!files.length) return;
    const room = maxFiles() - SM.mms.length;
    if (room <= 0) {
        $j.Ui.Dialog.open({tone:'warn', title:`이미지는 최대 ${maxFiles()}장입니다.`});
        return;
    }
    const picked = files.slice(0, room);
    const $grid = SM.$modal.find('#sm_mms_grid');
    picked.forEach(file => {
        const $ph = $('<div class="sm-mms-thumb"><i class="fa fa-spinner fa-spin"></i></div>').appendTo($grid);
        const fd = new FormData();
        fd.append('file', file);
        fd.append('channel', SM.channel);
        $.ajax({ url: '/adm/ajax/sms-send/mms-upload', method: 'POST', data: fd, processData: false, contentType: false, dataType: 'json' })
         .done(res => {
             $ph.remove();
             if (!res.result) { $j.Ui.Dialog.open({tone:'danger', title: res.message || '이미지 업로드 실패'}); return; }
             if (SM.mms.length >= maxFiles()) return;
             SM.mms.push({ fileKey: res.fileKey, url: res.url, expired: res.expired, file_id: res.file_id, bytes: res.bytes, name: file.name,
                           media: res.media, media_expired: res.media_expired, width: res.width, height: res.height });
             renderMms();
             refreshCompose();
         })
         .fail(() => { $ph.remove(); $j.Ui.Dialog.open({tone:'danger', title:'이미지 업로드 중 서버 오류'}); });
    });
}
function renderMms() {
    const $grid = SM.$modal.find('#sm_mms_grid').empty();
    SM.mms.forEach(f => {
        const $t = $('<div class="sm-mms-thumb"><span class="rm" title="빼기">×</span><span class="sz"></span></div>');
        if (f.url) $t.addClass('has-img').data('url', f.url).css('background-image', `url("${f.url}")`);
        else $t.prepend('<i class="fa fa-image"></i>');
        if (f.bytes) $t.find('.sz').text(Math.round(f.bytes / 1024) + 'KB');
        else $t.find('.sz').remove();
        $t.attr('title', (f.name || '') + (f.width ? ` · ${f.width}×${f.height}` : ''));
        $grid.append($t);
    });
    SM.$modal.find('#sm_mms_add').toggle(SM.mms.length < maxFiles());
}

// ── 최근 발송 — 최근 수동발송 5건 (g5_sms_send_requests). 고르면 폼을 그대로 채우고, 발송만 누르면 다시 나간다 ──
function loadRecent() {
    const $list = SM.$modal.find('#sm_recent_list').html('<div class="empty"><i class="fa fa-spinner fa-spin"></i> 불러오는 중…</div>');
    $.post('/adm/ajax/sms-send/recent', { is_ad: SM.ad ? 1 : 0 }, function (res) {
        SM.recent = (res.result && res.list) ? res.list : [];
        renderRecent();
    }, 'json').fail(function () {
        SM.recent = null;
        $list.html('<div class="empty">최근 발송을 불러오지 못했습니다.</div>');
    });
}
function renderRecent() {
    const $list = SM.$modal.find('#sm_recent_list').empty();
    if (!SM.recent.length) { $list.html(`<div class="empty">최근 ${SM.ad ? '광고' : '수동'}발송이 없습니다.</div>`); return; }
    SM.recent.forEach((r, i) => {
        const when = String(r.created_at || '').substr(5, 11);     // MM-DD HH:MM
        const who  = r.manage_name || '시스템';
        const target = r.mode === 'segment'
            ? `${segmentSummaryOf(r.segment || {})} <span class="n">· ${Number(r.total).toLocaleString()}명</span>`
            : (r.mode === 'csv' ? `CSV ${Number(r.total).toLocaleString()}명` : directTargetLabel(r.to_phone));
        const atts = [];
        if ((r.mms_files || []).length)   atts.push(`이미지 ${r.mms_files.length}장`);
        if ((r.rcs_buttons || []).length) atts.push(`버튼 ${r.rcs_buttons.length}개`);
        const body = String(r.message || '').replace(/\s+/g, ' ').trim();
        $list.append(`<button type="button" class="sm-recent-item" title="이 내용으로 폼을 채웁니다">
                    <div class="r1">${i === 0 ? '<span class="last">직전</span>' : ''}<span class="when">${when}</span><span class="who">${escapeHtml(who)}</span>
                        <span class="badge-channel badge-${escapeHtml(r.msg_type)}">${escapeHtml(r.msg_type)}</span>${Number(r.is_ad) ? '<span class="ad">광고</span>' : ''}</div>
                    <div class="r2"><i class="fa ${r.mode === 'segment' ? 'fa-users' : 'fa-user'}" style="opacity:.6"></i> ${r.mode === 'segment' ? target : escapeHtml(target)}</div>
                    <div class="r3">${atts.length ? `<span class="att">[${atts.join(' · ')}]</span> ` : ''}${escapeHtml(body)}</div>
                </button>`);
    });
}
/** 스냅샷의 받는번호(콤마로 여러 개) → '010-1234-5678 외 2명' */
function directTargetLabel(toPhone) {
    const list = String(toPhone || '').split(',').map(v => v.replace(/\D/g, '')).filter(v => v);
    if (!list.length) return '';
    const first = $j.Common.Util.phoneNumber(list[0]);
    return list.length > 1 ? `${first} 외 ${list.length - 1}명` : first;
}
/**
 * 불러오기 — 받는사람(번호 또는 분류 칩)·보내는 방식·보내는번호·본문·광고성·이미지·버튼을 그 요청 그대로.
 * 이미지는 저장된 fileKey 를 다시 쓴다 (만료됐으면 워커가 보관 주소에서 다시 올린다). 발송 버튼을 누르기 전까지 아무것도 나가지 않는다.
 */
function applyRecent(r) {
    const $m = SM.$modal;
    resetRecipient();
    // CSV 번호는 남기지 않으므로 내용만 불러오고 파일은 다시 고른다
    setMode(['segment', 'csv'].includes(r.mode) ? r.mode : 'direct');
    if (SM.mode === 'segment') {
        const seg = r.segment || {};
        if ((seg.member_type || []).length) seg.member_type.forEach(c => addChip('mtype', c, c));
        else addChip('mtype', ALL, '전체');   // 저장된 조건이 비어 있으면 = 전체 회원
        (seg.car_type    || []).forEach(c => addChip('ctype', c, c));
        (seg.sosok       || []).forEach(c => {
            if (SEGMENT_DICT.bonsa[c])     addChip('bonsa', c, SEGMENT_DICT.bonsa[c]);
            else if (SEGMENT_DICT.gisa[c]) addChip('gisa',  c, SEGMENT_DICT.gisa[c]);
        });
        $m.find('#sm_include_sosok').prop('checked', !!Number(seg.include_sosok));
        syncSegmentBoxes();   // 회원유형에 안 맞는 축(장비종류·소속)은 감추고 비운다
        SM.count = null;
        refreshCountBox();
        scheduleCount(0);
    } else if (SM.mode === 'direct') {
        const list = String(r.to_phone || '').split(',').map(v => v.replace(/\D/g, '')).filter(v => v.length >= 9)
            .filter((v, i, a) => a.indexOf(v) === i);
        $m.find('#sm_to_list').empty();
        if (list.length) list.forEach(d => addToRow(false, $j.Common.Util.phoneNumber(d)));
        else addToRow();
        refreshFinal();
        refreshSendButton();
    }

    // 보내는 방식 — 첨부를 먼저 비워야 RCS 전환이 '이미지 비움' 안내를 띄우지 않는다
    SM.mms = [];
    $m.find('#sm_btn_list').empty();
    setChannel(r.channel === 'rcs' ? 'rcs' : 'sms');

    const $from = $m.find('#sm_from_phone');
    if (r.from_phone && $from.find(`option[value="${r.from_phone}"]`).length) $from.val(r.from_phone);
    $m.find('#sm_message').val(r.message || '');
    $m.find('#sm_is_ad').prop('checked', SM.ad);   // 광고 여부는 모달 모드가 정한다 (목록도 모드별로만 온다)

    SM.mms = (r.mms_files || []).slice(0, maxFiles()).map(f => ({
        fileKey: f.fileKey, url: f.url, expired: f.expired, file_id: f.file_id,
        media: f.media, media_expired: f.media_expired, bytes: null, name: '불러온 이미지',
    }));
    renderMms();
    if (SM.channel === 'rcs') {
        (r.rcs_buttons || []).forEach(b => {
            addButtonRow();
            const $row = $m.find('#sm_btn_list .sm-btn-row').last();
            $row.find('[data-k="type"]').val(b.type === 'tel' ? 'tel' : 'url').trigger('change');
            $row.find('[data-k="label"]').val(b.label || '');
            $row.find('[data-k="value"]').val(b.value || '');
        });
    }
    showPreview(false);
    refreshCompose();
    refreshCountBox();
    $j.Ui.Toast.show('불러왔습니다. 내용을 확인하고 발송을 누르세요.', {type: 'success', timeout: 2500});
}

// ── 발송 ──
/** 확인창이 뜨기 전 일정을 받아 오는 사이에 또 눌러도 한 번만 돈다 — 두 번 돌면 유료 문자가 두 번 등록된다 */
async function doSend() {
    const state = SM;
    if (state.sending) return;
    state.sending = true;
    try {
        await runSend();
    } finally {
        state.sending = false;
    }
}

async function runSend() {
    const $m = SM.$modal;
    const fromPhone = $j.Common.Util.phoneNumber(SM.channel === 'rcs' ? MMS_RULE.rcsSender : $m.find('#sm_from_phone').val());
    const message   = String($m.find('#sm_message').val()).trim();
    const isAd      = $m.find('#sm_is_ad').is(':checked') ? 1 : 0;

    if (fromPhone.replace(/\D/g, '').length < 8) {
        $j.Ui.Dialog.open({tone:'warn', title:'보내는번호를 확인해주세요.'});
        return;
    }
    if (!message) {
        $j.Ui.Dialog.open({tone:'warn', title:'메시지를 입력해주세요.'});
        return;
    }
    if (eucKrBytes(composedMessage()) > LMS_BYTE_LIMIT) {
        $j.Ui.Dialog.open({tone:'warn', title:`본문이 ${LMS_BYTE_LIMIT.toLocaleString()}바이트를 넘습니다.`});
        return;
    }
    // 썸네일 자리에 아직 올리는 중인 것이 있으면 기다리게
    if ($m.find('#sm_mms_grid .fa-spinner').length) {
        $j.Ui.Dialog.open({tone:'warn', title:'이미지가 아직 올라가는 중입니다.'});
        return;
    }

    if (SM.channel === 'rcs' && composedMessage().length > MMS_RULE.rcsTextLimit) {
        $j.Ui.Dialog.open({tone:'warn', title:`RCS 본문은 ${MMS_RULE.rcsTextLimit.toLocaleString()}자까지입니다.`});
        return;
    }

    const buttons = SM.channel === 'rcs' ? collectButtons() : [];
    if (buttons.length > buttonsMax()) {
        $j.Ui.Dialog.open({tone:'warn', title:`이 RCS 는 버튼을 ${buttonsMax()}개까지 달 수 있습니다.`});
        return;
    }
    if (buttons.some(b => !b.label || !b.value)) {
        $j.Ui.Dialog.open({tone:'warn', title:'버튼명과 주소(번호)를 모두 적어주세요.'});
        return;
    }

    const payload = { mode: SM.mode, channel: SM.channel, from_phone: fromPhone, message, is_ad: isAd,
                      mms_files: JSON.stringify(SM.mms), rcs_buttons: JSON.stringify(buttons) };
    const type = msgType();

    if (SM.mode === 'segment') {
        if (!mtypeChosen()) { $j.Ui.Dialog.open({tone:'warn', title:'회원유형을 먼저 고르세요.', desc:'모든 회원에게 보내려면 「전체」를 고릅니다.'}); return; }
        const n = effectiveCount();
        if (n === null) { $j.Ui.Dialog.open({tone:'warn', title:'대상 인원을 아직 세는 중입니다.'}); return; }
        if (n === 0) {
            $j.Ui.Dialog.open({tone:'warn', title: isAd ? '분류에 드는 광고 수신동의 회원이 없습니다.' : '분류에 드는 회원이 없습니다.'});
            return;
        }
        const ok = await confirmSend(n, `${n.toLocaleString()}명에게 ${type} 문자를 보냅니다`, [
            { k: '분류', v: segmentSummary() },
            { k: '채널', v: type + (SM.mms.length ? ` · 이미지 ${SM.mms.length}장` : '') + (buttons.length ? ` · 버튼 ${buttons.length}개` : '') },
            { k: '광고성', v: isAd ? `${AD_RULE.prefix} 표기 · 수신거부 번호 안내 · 수신동의자만` : '아니오 (안내성)' },
        ]);
        if (!ok) return;
        payload.segment = segmentPayload();
    } else if (SM.mode === 'csv') {
        const n = SM.csv ? SM.csv.phones.length : 0;
        if (!n) { $j.Ui.Dialog.open({tone:'warn', title:'CSV 파일을 먼저 올려주세요.'}); return; }
        const ok = await confirmSend(n, `${n.toLocaleString()}명에게 ${type} 문자를 보냅니다`, [
            { k: '파일', v: SM.csv.name },
            { k: '채널', v: type + (SM.mms.length ? ` · 이미지 ${SM.mms.length}장` : '') + (buttons.length ? ` · 버튼 ${buttons.length}개` : '') },
            { k: '광고성', v: isAd ? `${AD_RULE.prefix} 표기 · 수신거부 번호 안내 · 수신동의자만` : '아니오 (안내성)' },
        ]);
        if (!ok) return;
        payload.to_phones = JSON.stringify(SM.csv.phones);   // 배열로 보내면 max_input_vars 에 잘린다
    } else {
        const $bad = badToRow();
        const to = toPhones();
        if ($bad || !to.length) {
            ($bad || $m.find('#sm_to_list .sm-to-phone').first()).closest('.sm-to-row').addClass('is-bad').find('.sm-to-phone').trigger('focus');
            $m.find('#sm_phone_hint').text('받는번호를 확인해주세요.').css('color','var(--adm-c-dc3545, #dc3545)');
            return;
        }
        // 한 명이면 평소엔 확인 없이 나가지만, 오늘 못 가거나 자동 문자 몫을 쓰면 알려야 한다 — 모달에 받아 둔 값은 낡았을 수 있어 지금 다시 본다
        const solo = to.length === 1 ? await fetchPlan(1).catch(() => null) : null;
        if (to.length > 1 || (solo && (planSpills(solo) || planAutoLine(solo)))) {
            const ok = await confirmSend(to.length, `${to.length.toLocaleString()}명에게 ${type} 문자를 보냅니다`, [
                { k: '받는번호', v: to.map(d => $j.Common.Util.phoneNumber(d)).join(', ') },
                { k: '채널', v: type + (SM.mms.length ? ` · 이미지 ${SM.mms.length}장` : '') + (buttons.length ? ` · 버튼 ${buttons.length}개` : '') },
                { k: '광고성', v: isAd ? `${AD_RULE.prefix} 표기 · 수신거부 번호 안내` : '아니오 (안내성)' },
            ]);
            if (!ok) return;
        }
        payload.to_phones = to;
    }

    const $btn = $m.find('.sm-send-btn').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> 발송 중...');
    const restore = () => { $btn.prop('disabled', false); refreshSendButton(); };

    $.post('/adm/ajax/sms-send/send', payload, function (res) {
        if (!res.result) {
            restore();
            $j.Ui.Dialog.open({tone:'danger', title: res.message || '발송 실패'});
            return;
        }
        const sent = Number(res.sent);
        const head = `${sent.toLocaleString()}건 발송 등록됨 · 회차 ${res.group_id}`;
        const later = res.plan && res.plan.days.length && planSpills(res.plan) ? ` ${planHeadline(res.plan)}. ${planRestLine(res.plan)}` : '';
        $j.Ui.Toast.show(`${head} — 잠시 뒤 발송됩니다.${later} 결과는 목록의 처리상태에서 확인하세요.${res.dev_note ? ' ' + res.dev_note : ''}`, {type: 'success', timeout: 5000});
        $j.Ui.JBModal.close('sms-send-modal');
        reloadTable();
    }, 'json').fail(function () {
        restore();
        $j.Ui.Dialog.open({tone:'danger', title:'서버 오류'});
    });
}

/** MMS 첨부 — mms_files JSON [{fileKey,url,expired}]. 보관 주소(url)가 있으면 그림, 없으면 키만 */
function mmsDetailBlock(row) {
    if (!['MMS', 'RCS'].includes(row.msg_type) || !row.mms_files) return '';
    let files = [];
    try { files = JSON.parse(row.mms_files) || []; } catch (e) { return ''; }
    if (!files.length) return '';
    const imgs = files.map(f => f.url
        ? `<a href="${escapeHtml(f.url)}" target="_blank"><img class="sm-detail-img" src="${escapeHtml(f.url)}" alt=""></a>`
        : `<code style="font-size:11px">${escapeHtml(f.fileKey || '')}</code>`).join(' ');
    return `<h6 class="mt-3">첨부 이미지 <small class="text-muted">${files.length}장</small></h6><div>${imgs}</div>`;
}

/**
 * 처리상태. 실패는 bizgo_code 존재 여부로 갈린다.
 *   · 코드 있음 → '실패'   (비즈고가 거절 — 코드 보고 설정 수정)
 *   · 코드 없음 → 'JB실패' (비즈고에 닿지도 못함 — 수동 재발송 필요)
 * 정상(A000)은 저장하지 않으므로 성공 행의 bizgo_code 는 항상 NULL.
 */
function statusBadge(row) {
    const s = String(row.status);
    if (s === '1') return '<span class="badge-status badge-success">성공</span>';
    if (s === '0') return '<span class="badge-status badge-pending">대기</span>';
    // 개발환경에서 막은 건 — 실패가 아니다(보내려다 못 간 게 아니라 안 보낸 것)
    if (s === '3') return '<span class="badge-status badge-pending" title="환경설정 > 개발·테스트 의 문자 테스트 폰이 비어 있어 발송하지 않았습니다">개발차단</span>';

    return row.bizgo_code
        ? '<span class="badge-status badge-failed">실패</span>'
        : '<span class="badge-status badge-jbfail">JB실패</span>';
}

/**
 * 실패코드 → CS 가 바로 조치할 수 있는 안내.
 * 정상코드(A000/0000)는 저장하지 않으므로 여기 없다. 매핑 없는 코드는 코드만 노출.
 */
const BIZGO_CODE_DESC = {
    'A010': 'API 키 없음 — Authorization 헤더 확인',
    'A020': 'Rate Limit 초과 — 잠시 후 재발송',
    'A030': 'API 키 만료/비활성 — 콘솔에서 키 상태 확인',
    'A040': '권한 없음 — 해당 채널 사용 계약 확인',
    'A050': 'IP 차단 — 허용 IP 등록 여부 확인',
    '1001': 'destinations 필드 오류 — 수신자 번호·형식 확인',
    '1002': 'messageFlow 필드 오류 — 채널 파라미터 확인',
    '1003': '필수 파라미터 누락 — 요청 스키마 검토',
    '1010': '발신번호 미등록 — 콘솔에서 발신번호 등록',
    '1011': '발신번호 차단 — 이통사 차단 여부 확인',
    '1020': '알림톡 템플릿 불일치 — 템플릿 코드·변수 확인',
    '1021': '알림톡 템플릿 미승인 — 카카오 심사 대기/재신청',
    '1030': 'RCS 브랜드 미등록 — 브랜드 등록 확인',
    '1040': '잔액 부족 — 충전 후 재발송',
    '9999': '비즈고 내부 서버 오류 — 잠시 후 재발송',
};

/** 용도 대분류 + 세부용도. 매핑 없는 코드는 코드 그대로 노출. */
function purposeCell(row) {
    const p = row.purpose || '';
    if (!p) return '-';

    const label  = PURPOSE_LABELS[p] || p;
    const d      = row.detail_purpose || '';
    const detail = d ? (DETAIL_LABELS[d] || d) : '';

    return escapeHtml(label)
         + (detail ? ` <small class="text-muted">${escapeHtml(detail)}</small>` : '');
}

/** 비즈고가 거절한 코드. 값이 있다는 것 자체가 실패 — 정상은 저장되지 않는다. */
function bizgoCell(row) {
    const code = row.bizgo_code || '';
    if (!code) return '<span class="text-muted">-</span>';

    // 안내문구는 길 수 있으므로 자르지 않고 셀 안에서 줄바꿈시킨다.
    const desc = BIZGO_CODE_DESC[code] || '';

    return `<span class="badge-code badge-code-err">${escapeHtml(code)}</span>`
         + (desc ? ` <small class="text-muted bizgo-desc">${escapeHtml(desc)}</small>` : '');
}

function bizgoDetailRows(row) {
    const code = row.bizgo_code || '';
    if (!code) return '';

    const desc = BIZGO_CODE_DESC[code];
    return `
                <tr><th>비즈고 코드</th><td>
                    <span class="badge-code badge-code-err">${escapeHtml(code)}</span>
                    ${desc ? escapeHtml(desc) : ''}
                </td></tr>
            `;
}

function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
}

// ── 표가 그리는 링크의 동작 — data-ss="이름" ──
const CLICK = {
    detail: (el) => showDetail(Number(el.dataset.n)),
    cancelRun: (el) => cancelRun(el),
};

export default class SmsSend {
    initialize() {
        // JS 가 그리는 버튼 — data-ss="동작" 을 위임으로 받는다 (아래 CLICK 표)
        $(document).on('click', '[data-ss]', function (e) {
            const fn = CLICK[this.dataset.ss];
            if (!fn) return;
            if (this.tagName === 'A') e.preventDefault();
            fn(this);
        });

        // blade 마크업에서 옮긴 핸들러 — 발송내역 검색줄
        $('#btnSsReload').on('click', () => reloadTable());
        $('#btnSsReset').on('click', () => resetFilter());
        $('#btnSsSend').on('click', () => openSendModal());
        $('#dn_send_btn').on('click', () => openSendModal(true));   // 광고 문자 탭 — 광고 모드로

        // ── 아래는 예전 blade 인라인에서 최상위로 돌던 것 (순서 그대로) ──
        $(function () {
            // 발송내역 검색조건 — 이 탭 전용, 통계에는 영향 없음
            $('#f_date_from, #f_date_to').mobiscroll().datepicker({
                controls: ['calendar'],
                dateFormat: 'YYYY-MM-DD',
                locale: mobiscroll.localeKo,
                buttons: [],
                onChange: reloadTable,   // 날짜 고르면 즉시 조회
            });
            $('#f_msg_type, #f_status, #f_manage_num, #f_purpose').on('change', reloadTable);
            $('#f_keyword').on('keydown', e => { if (e.key === 'Enter') reloadTable(); });

            // 통계 조회기간 — 발송내역 검색조건과 별개, 프리셋 버튼으로만 고른다
            $('#ss-period-group button').on('click', function () {
                $('#ss-period-group button').removeClass('active');
                $(this).addClass('active');
                reloadStats();
            });

            // 탭 전환 — 같은 화면 안(발송내역 ↔ 통계)
            $('#ss-tabs a').on('click', function (e) {
                e.preventDefault();
                const tab = $(this).data('tab');
                $('#ss-tabs a').removeClass('active');
                $(this).addClass('active');
                $('.ss-pane').hide();
                $(`.ss-pane[data-pane="${tab}"]`).show();
                if (tab === 'stats') reloadStats();
            });

            // 광고 문자 탭 — 080 수신거부 CSV 반영
            $('#dn_csv_btn').on('click', () => $('#dn_csv_file').trigger('click'));
            $('#dn_csv_file').on('change', importOptOut);

            loadTable();
            loadRunning();
        });
    }
}
